import { useTheme } from "../../context/theme-context";
export const Logo = ({ width, height }) => {
  const { theme } = useTheme();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
        fill={theme === "dark" ? "#ffff" : "#000000"}
        stroke="none"
      >
        <path d="M572 1077 l-72 -72 73 -73 72 -72 73 73 72 72 -73 73 -72 72 -73 -73z" />
        <path d="M280 895 l0 -105 105 0 105 0 0 105 0 105 -105 0 -105 0 0 -105z" />
        <path d="M800 895 l0 -105 105 0 105 0 0 105 0 105 -105 0 -105 0 0 -105z" />
        <path
          d="M500 890 l0 -104 68 -71 67 -70 -70 68 -71 67 -104 0 -104 0 69 -70
70 -71 105 3 105 3 3 105 3 105 -71 70 -70 69 0 -104z"
        />
        <path
          d="M717 922 l-68 -68 3 -105 3 -104 105 -3 105 -3 70 71 69 70 -104 0
-104 0 -71 -67 -70 -68 68 71 68 70 -3 102 -3 103 -68 -69z"
        />
        <path d="M202 707 l-72 -72 73 -73 72 -72 73 73 72 72 -73 73 -72 72 -73 -73z" />
        <path d="M942 707 l-72 -72 73 -73 72 -72 73 73 72 72 -73 73 -72 72 -73 -73z" />
        <path
          d="M355 560 l-69 -70 104 0 104 0 71 68 70 67 -67 -70 -68 -71 0 -104 0
-104 70 69 71 70 -3 105 -3 105 -105 3 -105 3 -70 -71z"
        />
        <path
          d="M657 623 c-4 -3 -7 -52 -7 -107 l0 -102 70 -69 70 -69 0 104 0 104
-67 71 -68 70 70 -67 71 -68 104 0 104 0 -69 70 -69 70 -102 0 c-55 0 -104 -3
-107 -7z"
        />
        <path d="M280 375 l0 -105 105 0 105 0 0 105 0 105 -105 0 -105 0 0 -105z" />
        <path d="M800 375 l0 -105 105 0 105 0 0 105 0 105 -105 0 -105 0 0 -105z" />
        <path d="M572 337 l-72 -72 73 -73 72 -72 73 73 72 72 -73 73 -72 72 -73 -73z" />
      </g>
    </svg>
  );
};

